import { PostRequest } from "../../service"

const ControllerName = "Broker"

export const CreateBroker = (data) =>
    PostRequest(`${ControllerName}`, data)
